module.exports = __webpack_public_path__ + "img/sheldon_plankton.e921b5be.jpg";